import { ColumnDef } from "@tanstack/react-table";
import React from "react";
import { Album, Genre, TrackRelease } from "../../api/useMusicApi";
import { TableRenderUtils } from "../../components/Table/TableRenderUtils";
import { truncate } from "../../utils";
import { CountryMetaAllPill } from "../../components/CountryMetaAllPill";
import { Link } from "react-router-dom";

export function tracksColumnsDefinition(
  t: any,
  genres: Genre[]
): Array<ColumnDef<TrackRelease, any>> {
  return [
    {
      id: "Image",
      header: "",
      size: 100,
      enableSorting: false,
      accessorFn: (value) => value.album?.image_url_template,
      cell: (value) => {
        const url = value.getValue()
          ? value.getValue().replace("{}", "medium")
          : "/album_cover_default_150x150.jpg";
        return TableRenderUtils.renderBaseContent(
          <img
            height={100}
            width={100}
            className={"border rounded"}
            src={url}
            alt={"album_preview"}
          />
        );
      }
    },
    {
      id: "Tracks",
      header: `${t("name")}`,
      size: 300,
      enableSorting: false,
      accessorFn: (value) => value.display_title,
      cell: (value) => {
        const { album, id, display_title, external_id, code_isrc } =
          value.row.original;
        return TableRenderUtils.renderBaseContent(
          <div>
            <div className={"text-lg"}>
              <Link
                className={"dark:text-white"}
                to={`/music/albums/${album?.id}?track_id=${id}&step=1`}
              >
                {truncate(display_title, 80)}
              </Link>{" "}
              <CountryMetaAllPill />
            </div>
            {code_isrc != null && (
              <div
                style={{ fontSize: "12px" }}
                className={"text-sm text-gray-400 mr-0.5"}
              >
                ISRC: {code_isrc}
              </div>
            )}
            {external_id != null && (
              <div
                style={{ fontSize: "12px" }}
                className={"text-sm text-gray-400"}
              >
                External ID: {external_id}
              </div>
            )}
            {album != null && album.code_icpn && (
              <div
                style={{ fontSize: "12px" }}
                className={"text-sm text-gray-400 mr-0.5"}
              >
                UPC: {album.code_icpn}
              </div>
            )}
          </div>
        );
      }
    },
    {
      id: "Artist",
      header: `${t("artist")}`,
      size: 400,
      enableSorting: false,
      accessorFn: (value) => value.country_meta,
      cell: (value) => {
        let content = null;
        if (
          value.row.original.country_meta == null ||
          value.row.original.country_meta.artists == null
        ) {
          content = "--";
        } else {
          content = (
            <>
              {truncate(
                value.row.original.country_meta.artists.main
                  .map((t) => t.ALL)
                  .join(", "),
                80
              )}
              <span>
                {value.row.original.country_meta.artists.featured
                  .map((t) => t.ALL)
                  .join(", ")}
              </span>{" "}
              <CountryMetaAllPill />
            </>
          );
        }
        return TableRenderUtils.renderBaseContent(content);
      }
    },
    {
      id: "Album",
      header: `${t("album")}`,
      size: 400,
      enableSorting: false,
      accessorFn: (value) => value.album,
      cell: (value) => {
        const { album } = value.row.original;
        const content = (
          <>
            {album?.country_meta != null && (
              <>
                <span>{album.country_meta.title.ALL}</span>{" "}
                <CountryMetaAllPill />
              </>
            )}
          </>
        );
        return TableRenderUtils.renderBaseContent(content);
      }
    },
    {
      id: "Genres",
      header: `${t("genres")}`,
      size: 300,
      enableSorting: false,
      accessorFn: (value) => value.genres,
      cell: (value) => {
        const { genres: draftGenres } = value.row.original;
        return TableRenderUtils.renderBaseContent(
          <>
            {draftGenres
              .map(
                (draftGenre) => genres.find((g) => draftGenre == g.id)?.title
              )
              .join(", ")}
          </>
        );
      }
    }
  ];
}
